import { CURRENCY_CODE_FORMAT } from 'state/intl/types';

export function formatCurrencyCodeForRegion(
  region: string,
  code: CURRENCY_CODE_FORMAT | undefined
): string {
  return `${region} - ${code}`;
}
